import store from "../store/index.js";

export function nodefunction(itemData, item){
  // console.log(itemData)
  // console.log(store.state.change_tab)
  if(store.state.change_tab){
    return;
  }
  let type = itemData.type,html,empty="--";
  // 解析后台数据
  // if(itemData.properties){
  //   var riskinfo = itemData.properties.riskinfo
  //   if(riskinfo){
  //     if(/\|/g.test(riskinfo)){
  //       var riskinfo_array = riskinfo.split('|');
  //       var riskinfo_Temarray =[]
  //       for(var i = 0;i<riskinfo_array.length ; i++){
  //         var k_zhi = riskinfo_array[i].split('-').shift()
  //         var v_json = JSON.parse(riskinfo_array[i].split('-').splice(1).join("-"))
  //         var riskinfo_newJson = {type:k_zhi,v_json:v_json}
  //         riskinfo_Temarray.push(riskinfo_newJson)
  //       }
  //     }else{
  //       var one_riskType = riskinfo.split('-').shift()
  //       var riskinfo_string = riskinfo.split('-').splice(1).join("-");
  //       var riskinfo_json = JSON.parse(riskinfo_string)
  //       var one_riskJson ={type:one_riskType,v_json:riskinfo_json}
  //       var riskinfo_Temarray =[]
  //       riskinfo_Temarray.push(one_riskJson)
  //     }
  //   }
  // }

  // 企业
  if(type == 1){
    html = "<div class='net-hover'>" +
          "<p class='netTitle'>"+ itemData.properties.name +"</p>"
          +"<p class='typeColor'>"+ (itemData.properties.SYRtype|| empty)+"</p>"+
          "<div class='netContent'>"
    if(itemData.properties.entstatus == 1){
      html += "<p class='entstatus_1'>在营</p></br>"
    }else if(itemData.properties.entstatus == 2){
      html += "<p class='entstatus_2'>吊销</p></br>"
    }else if(itemData.properties.entstatus == 3){
      html += "<p class='entstatus_3'>注销</p></br>"
    }else if(itemData.properties.entstatus == 4){
      html += "迁出</br>"
    }else if(itemData.properties.entstatus == 5){
      html += "撤销</br>"
    }else if(itemData.properties.entstatus == 6){
      html += "临时(个体工商户使用)</br>"
    }
    html+="注册号："+(itemData.properties.regno || empty) + "</br>"+
          "统一信用代码："+(itemData.properties.creditcode|| empty)  +"</br>"+
          "成立日期："+(itemData.properties.esdate || empty)  + "</br>"+
          "注册资本："+(itemData.properties.regcap || empty)  +" (万/"+(itemData.properties.regcapcur_desc|| empty)+")</br>"+
          "行业："+(itemData.properties.industryphy_desc || empty)  +"</br>"
    if(itemData.innode != true){
      html+="持股占比："+(itemData.properties.cgzb || empty)  +"%</br>"
    }

          // +(itemData.properties.riskinfo||'')  +
    // if(riskinfo_Temarray.length!=0){
    //   html+="haha"
    // }
    // if(!riskinfo){
    //   html+=''
    // }else{
    //   for(var i = 0;i<riskinfo_Temarray.length;i++){
    //     html+="<h4 class='riskinfo_Temarray'>"+(riskinfo_Temarray[i].type)+"</h4>"
    //     html+="<p class='riskinfo_content'>"
    //     if(riskinfo_Temarray[i].type == '失信被执行人'){
    //
    //       html+='身份证号明文：'+(riskinfo_Temarray[i].v_json.fsx_sfzh_all||empty)+ "</br>"
    //       +'法定代表人或者负责人姓名：'+(riskinfo_Temarray[i].v_json.fsx_frdb||empty)+ "</br>"
    //       +"执行法院："+(riskinfo_Temarray[i].v_json.fsx_zxfy||empty)+ "</br>"
    //       +"立案时间："+(riskinfo_Temarray[i].v_json.fsx_lasj||empty)+ "</br>"
    //       +"被执行人的履行情况："+(riskinfo_Temarray[i].v_json.fsx_lxqk||empty)+ "</br>"
    //       +"失信被执行人行为具体情形："+(riskinfo_Temarray[i].v_json.fsx_sxjtqx||empty)+ "</br>"
    //       +"发布时间："+(riskinfo_Temarray[i].v_json.fsx_fbdate||empty)+'；'+"</br>"
    //     }else if(riskinfo_Temarray[i].type =='企业经营异常名录'){
    //       html+='列入日期：'+(riskinfo_Temarray[i].v_json.indate||empty)+ "</br>"
    //       +'移除日期：'+(riskinfo_Temarray[i].v_json.outdate||empty)+ "</br>"
    //       +'列入原因：'+(riskinfo_Temarray[i].v_json.inreason||empty)+ "</br>"
    //       +'移除原因：'+(riskinfo_Temarray[i].v_json.outreason||empty)+"</br>"
    //     }else if(riskinfo_Temarray[i].type =='被执行人'){
    //       html +='状态：'+(riskinfo_Temarray[i].v_json.fss_status||empty)+ "</br>"
    //       +'执行法院：'+(riskinfo_Temarray[i].v_json.fss_enfcourt||empty)+ "</br>"
    //       +'执行标的：'+(riskinfo_Temarray[i].v_json.fss_money||empty)+ "</br>"
    //       +'立案时间：'+(riskinfo_Temarray[i].v_json.fss_time||empty)+"</br>"
    //     }else if(riskinfo_Temarray[i].type =='严重违法'){
    //       html +='列入严重违法企业名单原因：'+(riskinfo_Temarray[i].v_json.brl_inr||empty)+ "</br>"
    //       +'列入日期：'+(riskinfo_Temarray[i].v_json.brl_idat||empty)+ "</br>"
    //       +'移出严重违法企业名单原因：'+(riskinfo_Temarray[i].v_json.brl_onr||empty)+ "</br>"
    //       +'移出日期：'+(riskinfo_Temarray[i].v_json.brl_odat||empty)+"</br>"
    //     }
    //   }
    //
    // }
          +"</p></div>" +
     "</div>";
  }
  // 人员
  if(type == 2){
    html = "<div class='transition-layer'>" +
      "<p class='transition-content'>"+ itemData.properties.name +"</p>"+
      "<p class='typeColor'>"+ itemData.properties.SYRtype +"</p>"+
      "<p class='transition-content'>持股占比："+ (itemData.properties.cgzb||empty) +"%</p>"+
    "</div>";
  }
  // 疑似关系
  // if(type == 3 || type == 4 || type == 5&&itemData.properties){
  //   html =  "<div class='transition-layer'>"+
  //           "<p>"+itemData.properties.samevalue+"</p>"
  //           "</div>";
  // }else if(type == 3 || type == 4 || type == 5&&!itemData.properties){
  //   html =  "<div class='transition-layer'>"+
  //           "<p>--</p>"
  //           "</div>";
  // }
  // 十大股东
  // if(type == 6){
  //   html = "<div class='transition-layer'>" +
  //     "<p class='transition-content'>"+ (itemData.properties.name||'') +"</p>" +
  //     // "<p style='word-break:break-all;'>"+
  //     // "人员标识："+itemData.properties.zsid +"</br>"+
  //      (itemData.properties.riskinfo||'')  +
  //   "</div>";
  // }
  // // 风险视图中新增的节点
  // if(type == 0){
  //   html = "<div class='transition-layer'>" +
  //     "<p class='transition-content'>"+ itemData.name +"</p>" +
  //   "</div>";
  // }
  // if(itemData.properties&&itemData.properties.pathLength!=null){
  //   html += "<p class='transition-riskinfo'>风险系数："+itemData.properties.pathLength+"</p></br>"
  //
  // }else{
  //   html+=""
  // }
  return html;
}

export function linkfunction(itemData, item){
  if(store.state.change_tab){
    return;
  }
  var type = itemData.type,html="",empty = "--";

  // 展示疑似关系
  // if(itemData.type == 3 || itemData.type == 4 || itemData.type == 5){
  //
  //   html += "<div class='transition-line'>";
  //   html += "<p> "+item.from.label+"</p>";
  //   if(itemData.type == 3){
  //     html += "<p class='relation'>同一联系方式</p>";
  //   }
  //   if(itemData.type == 4){
  //     html += "<p class='relation'>同一办公地址</p>";
  //   }
  //   if(itemData.type == 5){
  //     html += "<p class='relation'>同一疑似地址</p>";
  //   }
  //
  //   var sameMsg = [];// 同一住宅地址，办公地址，电话企业或人员id
  //   var NodeIdSort = store.state.jsonSort_node
  //   if(NodeIdSort[itemData.to].type == 3||NodeIdSort[itemData.to].type == 4||NodeIdSort[itemData.to].type == 5){
  //
  //     for(var i = 0;i<store.state.netResult.links.length;i++){
  //       if(store.state.netResult.links[i].to == itemData.to){
  //         sameMsg.push(store.state.netResult.links[i].from)
  //       }
  //     }
  //   }else{
  //     return html
  //   }
  //   for(var i=0;i<sameMsg.length;i++){
  //     if(NodeIdSort[sameMsg[i]].name != item.from.label){
  //       html += "<p> "+ NodeIdSort[sameMsg[i]].name+"</p>";
  //     }
  //   }
  //   html += "</div>";
  //   return html;
  // }

  html += "<div class='netHoverinvest'>";
  html += "<p>"+item.from.label + "</br>";
  html +="<p class='typeColor'>"
  if(itemData.type== 1||itemData.type== 10){
    html += "投资</br>";
  }
  if(itemData.type==2){
    html += "任职</br>";
  }
  if((itemData.type.toString()).indexOf("1") != -1&&(itemData.type.toString()).indexOf("2") != -1){
    html += "任职，投资</br>";
  }
  if(itemData.type==6){
    html += "控股</br>";
  }
  if((itemData.type.toString()).indexOf("6") != -1&&(itemData.type.toString()).indexOf("7") == -1&&(itemData.type.toString()).indexOf("2") != -1){
    html += "任职，控股</br>";
  }
  if(itemData.type == 7){
    html += "参股</br>";
  }
  if(itemData.type == 9){
    html += "十大股东投资"
  }
  if((itemData.type.toString()).indexOf("6") == -1&&(itemData.type.toString()).indexOf("7") != -1&&(itemData.type.toString()).indexOf("2") != -1){
    html += "任职，参股</br>";
  }
  if((itemData.type.toString()).indexOf("6") != -1&&(itemData.type.toString()).indexOf("7")!= -1&&(itemData.type.toString()).indexOf("2") == -1){
    html += "控股</br>";
  }
  if((itemData.type.toString()).indexOf("6") != -1&&(itemData.type.toString()).indexOf("7")!= -1&&(itemData.type.toString()).indexOf("2") != -1){
    html += "任职，控股</br>";
  }

  if(itemData.properties.fzr&&itemData.properties.fzr == "true"){
    html += "负责人</br>";
  }
  html+="</p>"
  if(itemData.type != 9){
    html += item.to.label + "</br>";
  }

  // 风险双击事件
  if(itemData.properties != null ){
    if(itemData.properties.conprop != undefined){
      var labelConprop = (itemData.properties.conprop*100).toFixed(2);
    }
    // // 投资下的属性
    // if((itemData.type.toString()).indexOf("1") != -1){
    //   html += "认缴出资日期："+(itemData.properties.condate || empty)  +"</br>";
    //   html += "认缴出资额："+(itemData.properties.subconam || empty)  + " (万元）</br>";
    //   html += "出资占比："+(labelConprop || empty)  +"%</br>";
    // }
    // // 十大股东属性
    // if((itemData.type.toString()).indexOf("9") != -1||(itemData.type.toString()).indexOf("10") != -1||(itemData.type.toString()).indexOf("11") != -1){
    //   html += "持股比例："+(itemData.properties.holderrto || empty)  +"%</br>";
    //   html += "持股数量："+(itemData.properties.holderamt || empty)  + " (股)</br>";
    //   html += "股份类型："+(itemData.properties.sharestype || empty)  +"</br>";
    // }
    // 工商总局和上市公司取并集
    if(itemData.properties.holderrto){
      html += "持股比例："+(itemData.properties.holderrto || empty)  +"%</br>";
      html += "持股数量："+(itemData.properties.holderamt || empty)  + " (股)</br>";
      html += "股份类型："+(itemData.properties.sharestype || empty)  +"</br>";
    }else{
      html += "认缴出资日期："+(itemData.properties.condate || empty)  +"</br>";
      html += "认缴出资额："+(itemData.properties.subconam || empty)  + " (万元）</br>";
      html += "出资占比："+(labelConprop || empty)  +"%</br>";
    }
    // 由于风险视图双击出现原来没有的节点 会出现properties为null 所以有这个判断
    if(itemData.properties.position_desc){
      html += "职位："+ (itemData.properties.position_desc || empty)  +"</br>";
    }

    if(itemData.properties.legal){
      html += "担任法人代表</br>";
    }
  }
  html +=  "</p>" ;
  html += "</div>";
  return html;
}

// export function nodeContent(itemData, item){
//   // $(document).on("click",".tab_change",function(){
//   //   store.state.change_tab = false
//   //   store.state.nl_Status = true
//   //   $("#nlContent").empty();
//   // });
//   var type = itemData.type,html="",empty = "--";
//   // if(itemData.properties){
//     // var riskinfo = itemData.properties.riskinfo
//     // if(riskinfo){
//     //   if(/\|/g.test(riskinfo)){
//     //     var riskinfo_array = riskinfo.split('|');
//     //     var riskinfo_Temarray =[]
//     //     for(var i = 0;i<riskinfo_array.length ; i++){
//     //       var k_zhi = riskinfo_array[i].split('-').shift()
//     //       var v_json = JSON.parse(riskinfo_array[i].split('-').splice(1).join("-"))
//     //       var riskinfo_newJson = {type:k_zhi,v_json:v_json}
//     //       riskinfo_Temarray.push(riskinfo_newJson)
//     //     }
//     //   }else{
//     //     var one_riskType = riskinfo.split('-').shift()
//     //     var riskinfo_string = riskinfo.split('-').splice(1).join("-");
//     //     var riskinfo_json = JSON.parse(riskinfo_string)
//     //     var one_riskJson ={type:one_riskType,v_json:riskinfo_json}
//     //     var riskinfo_Temarray =[]
//     //     riskinfo_Temarray.push(one_riskJson)
//     //   }
//     // }
//   // }
//   // 企业
//   if(type == 1){
//     html = "<div >" +
//           "<div class='nodeHeader'><span class='sp'></span><p class='com_info'>公司信息</p><a class='tab_change' >切换至页面弹框显示</a></div>"+
//           "<div class='nodeBody'>" +
//             "<p class='com_title'>"+ itemData.properties.name +"</p>"
//     if(itemData.properties.entstatus == 1){
//       html += "<p class='com_status'>在营</p>"
//     }else if(itemData.properties.entstatus == 2){
//       html += "<p class='com_status'>吊销</p>"
//     }else if(itemData.properties.entstatus == 3){
//       html += "<p class='com_status'>注销</p>"
//     }else if(itemData.properties.entstatus == 4){
//       html += "<p class='com_status'>迁出</p>"
//     }else if(itemData.properties.entstatus == 5){
//       html += "<p class='com_status'>撤销</p>"
//     }else if(itemData.properties.entstatus == 6){
//       html += "<p class='com_status'>临时(个体工商户使用)</p>"
//     }
//       html+="<p class='com_detail'>"+
//             "注册号："+(itemData.properties.regno || empty) + "</br>"+
//             "统一信用代码："+(itemData.properties.creditcode|| empty)  +"</br>"+
//             "成立日期："+(itemData.properties.esdate || empty)  + "</br>"+
//             "注册资本："+(itemData.properties.regcap || empty)  +" (万/"+(itemData.properties.regcapcur_desc|| empty)+")</br>"+
//             "行业："+(itemData.properties.industryphy_desc || empty)  +"</br>"
//
//             // (itemData.properties.riskinfo||'')  +
//             // if(!riskinfo){
//             //   html+=''
//             // }else{
//             //   for(var i = 0;i<riskinfo_Temarray.length;i++){
//             //     html+="<h4 class='riskinfo_Temarray'>"+(riskinfo_Temarray[i].type)+"</h4>"
//             //     if(riskinfo_Temarray[i].type == '失信被执行人'){
//             //
//             //       html+='身份证号明文：'+(riskinfo_Temarray[i].v_json.fsx_sfzh_all||empty)+ "</br>"
//             //       +'法定代表人或者负责人姓名：'+(riskinfo_Temarray[i].v_json.fsx_frdb||empty)+'</br>'
//             //       +"执行法院："+(riskinfo_Temarray[i].v_json.fsx_zxfy||empty)+'</br>'
//             //       +"立案时间："+(riskinfo_Temarray[i].v_json.fsx_lasj||empty)+'</br>'
//             //       +"被执行人的履行情况："+(riskinfo_Temarray[i].v_json.fsx_lxqk||empty)+'</br>'
//             //       +"失信被执行人行为具体情形："+(riskinfo_Temarray[i].v_json.fsx_sxjtqx||empty)+'</br>'
//             //       +"发布时间："+(riskinfo_Temarray[i].v_json.fsx_fbdate||empty)+"</br>"
//             //     }else if(riskinfo_Temarray[i].type =='企业经营异常名录'){
//             //       html+='列入日期：'+(riskinfo_Temarray[i].v_json.indate||empty)+ "</br>"
//             //       +'移除日期：'+(riskinfo_Temarray[i].v_json.outdate||empty)+ "</br>"
//             //       +'列入原因：'+(riskinfo_Temarray[i].v_json.inreason||empty)+ "</br>"
//             //       +'移除原因：'+(riskinfo_Temarray[i].v_json.outreason||empty)+ "</br>"
//             //     }else if(riskinfo_Temarray[i].type =='被执行人'){
//             //       html +='状态：'+(riskinfo_Temarray[i].v_json.fss_status||empty)+'</br>'
//             //       +'执行法院：'+(riskinfo_Temarray[i].v_json.fss_enfcourt||empty)+'</br>'
//             //       +'执行标的：'+(riskinfo_Temarray[i].v_json.fss_money||empty)+'</br>'
//             //       +'立案时间：'+(riskinfo_Temarray[i].v_json.fss_time||empty)+'</br>'
//             //     }else if(riskinfo_Temarray[i].type =='严重违法'){
//             //       html +='列入严重违法企业名单原因：'+(riskinfo_Temarray[i].v_json.brl_inr||empty)+'</br>'
//             //       +'列入日期：'+(riskinfo_Temarray[i].v_json.brl_idat||empty)+'</br>'
//             //       +'移出严重违法企业名单原因：'+(riskinfo_Temarray[i].v_json.brl_onr||empty)+'</br>'
//             //       +'移出日期：'+(riskinfo_Temarray[i].v_json.brl_odat||empty)+"</br>"
//             //     }
//             //   }
//             // }
//             +"</p>" +
//           "</div>"+
//      "</div>";
//   }
//   // 人员
//   if(type == 2){
//     html = "<div>" +
//       "<div class='nodeHeader'><span class='sp sp_p'></span><p class='com_info'>人员姓名</p><a class='tab_change' >切换至页面弹框显示</a></div>"+
//       "<div class='nodeBody'>" +
//         "<p class='com_title'>"+ itemData.properties.name +"</p>"
//         // if(!riskinfo){
//         //     html+=''
//         //   }else{
//         //     for(var i = 0;i<riskinfo_Temarray.length;i++){
//         //       html+="<h4>"+(riskinfo_Temarray[i].type)+"</h4>"
//         //       if(riskinfo_Temarray[i].type == '失信被执行人'){
//         //
//         //         html+="<p class='com_title'>"+'身份证号明文：'+(riskinfo_Temarray[i].v_json.fsx_sfzh_all||empty)+ "；"
//         //         +'法定代表人或者负责人姓名：'+(riskinfo_Temarray[i].v_json.fsx_frdb||empty)+'；'
//         //         +"执行法院："+(riskinfo_Temarray[i].v_json.fsx_zxfy||empty)+'；'
//         //         +"立案时间："+(riskinfo_Temarray[i].v_json.fsx_lasj||empty)+'；'
//         //         +"被执行人的履行情况："+(riskinfo_Temarray[i].v_json.fsx_lxqk||empty)+'；'
//         //         +"失信被执行人行为具体情形："+(riskinfo_Temarray[i].v_json.fsx_sxjtqx||empty)+'；'
//         //         +"发布时间："+(riskinfo_Temarray[i].v_json.fsx_fbdate||empty)+'；'+"</br>"
//         //       }else if(riskinfo_Temarray[i].type =='企业经营异常名录'){
//         //         html+="<p class='com_title'>"+'列入日期：'+(riskinfo_Temarray[i].v_json.indate||empty)+ "；"
//         //         +'移除日期：'+(riskinfo_Temarray[i].v_json.outdate||empty)+ "；"
//         //         +'列入原因：'+(riskinfo_Temarray[i].v_json.inreason||empty)+ "；"
//         //         +'移除原因：'+(riskinfo_Temarray[i].v_json.outreason||empty)+ "；"+"</br>"
//         //       }else if(riskinfo_Temarray[i].type =='被执行人'){
//         //         html +="<p class='com_title'>"+'状态：'+(riskinfo_Temarray[i].v_json.fss_status||empty)+'；'
//         //         +'执行法院：'+(riskinfo_Temarray[i].v_json.fss_enfcourt||empty)+'；'
//         //         +'执行标的：'+(riskinfo_Temarray[i].v_json.fss_money||empty)+'；'
//         //         +'立案时间：'+(riskinfo_Temarray[i].v_json.fss_time||empty)+'；'+"</br>"
//         //       }else if(riskinfo_Temarray[i].type =='严重违法'){
//         //         html +="<p class='com_title'>"+'列入严重违法企业名单原因：'+(riskinfo_Temarray[i].v_json.brl_inr||empty)+'；'
//         //         +'列入日期：'+(riskinfo_Temarray[i].v_json.brl_idat||empty)+'；'
//         //         +'移出严重违法企业名单原因：'+(riskinfo_Temarray[i].v_json.brl_onr||empty)+'；'
//         //         +'移出日期：'+(riskinfo_Temarray[i].v_json.brl_odat||empty)+'；'+"</br>"
//         //       }
//         //     }
//         //   }
//          +"</p>" +
//       "</div>"+
//     "</div>";
//   }
//   // 疑似关系
//   // if(type == 3 || type == 4 || type == 5){
//   //   html ="<div class='nodeHeader'><span class='sp sp_ys'></span><p class='com_info'>疑似关系</p><a class='tab_change' >切换至页面弹框显示</a></div>"+
//   //   "<div class='nodeBody'>"+
//   //           "<p class='com_detail'>"+itemData.properties.samevalue+"</p>"
//   //           "</div>";
//   // }
//   // // 十大股东
//   // if(type == 6){
//   //   html ="<div class='nodeHeader'><span class='sp sp_ys'></span><p class='com_info'>十大股东</p><a class='tab_change' >切换至页面弹框显示</a></div>"+
//   //   "<div class='nodeBody'>"+
//   //           "<p class='com_detail'>十大股东</p>"
//   //           "</div>";
//   // }
//   //
//   //
//   // // 风险额外节点的信息显示
//   // if(type == 0){
//   //   html ="<div class='nodeHeader'><span class='sp sp_ys'></span><p class='com_info'>名称</p><a class='tab_change' >切换至页面弹框显示</a></div>"+
//   //   "<div class='nodeBody'>"+
//   //           "<p class='com_title'>"+itemData.name+"</p>"
//   //           "</div>";
//   // }
//   // if(itemData.properties&&itemData.properties.pathLength!=null){
//   //   html += "风险系数："+itemData.properties.pathLength+"</br>"
//   //
//   // }
//   return html;
// }
//
// export function linkContent(itemData, item){
//   $(document).on("click",".tab_change",function(){
//     store.state.change_tab = false
//     store.state.nl_Status = true
//     $("#nlContent").empty();
//   });
//   var type = itemData.type,html="",empty = "";
//   if(itemData.type == 3 || itemData.type == 4 || itemData.type == 5){
//
//     html = "<div>";
//     html += "<div class='nodeHeader'><span class='sp sp_ys'></span><p class='com_info'>疑似关系</p><a class='tab_change' >切换至页面弹框显示</a></div>";
//     html += "<div class='nodeBody'>" ;
//     html += "<p class='com_detail'> "+item.from.label+"</p>";
//     if(itemData.type == 3){
//       html += "<p class='com_title'>同一联系方式</p>";
//     }
//     if(itemData.type == 4){
//       html += "<p class='com_title'>同一办公地址</p>";
//     }
//     if(itemData.type == 5){
//       html += "<p class='com_title'>同一住宅地址</p>";
//     }
//
//     var sameMsg = [];// 同一住宅地址，办公地址，电话企业或人员id
//     console.log(sameMsg)
//     var NodeIdSort = store.state.jsonSort_node
//     if(NodeIdSort[itemData.to].type == 3||NodeIdSort[itemData.to].type == 4||NodeIdSort[itemData.to].type == 5){
//
//       for(var i = 0;i<store.state.netResult.links.length;i++){
//         if(store.state.netResult.links[i].to == itemData.to){
//           sameMsg.push(store.state.netResult.links[i].from)
//         }
//       }
//     }
//     for(var i=0;i<sameMsg.length;i++){
//       if(NodeIdSort[sameMsg[i]].name != item.from.label){
//         html += "<p> "+ NodeIdSort[sameMsg[i]].name+"</p>";
//       }
//     }
//     html += "</div>";
//     html += "</div>";
//     return html;
//   }
//   html += "<div>";
//   // debugger
//   html += "<div class='nodeHeader'><span class='sp sp_company'></span><p class='com_info'>关系信息</p><a class='tab_change' >切换至页面弹框显示</a></div>";
//   html += "<div class='nodeBody'>" ;
//   html += "<p class='com_title'>"+item.from.label + "</br></p>";
//   if((itemData.type.toString()).indexOf("1") != -1||itemData.type== 10){
//     html += "<p class='com_status'>投资</br></p>";
//   }
//   if((itemData.type.toString()).indexOf("2") != -1){
//     html += "<p class='com_status'>任职</br></p>";
//   }
//
//   if(itemData.type==6){
//     html += "<p class='com_status'>控股</br></p>";
//   }
//   if((itemData.type.toString()).indexOf("6") != -1&&(itemData.type.toString()).indexOf("7") == -1&&(itemData.type.toString()).indexOf("2") != -1){
//     html += "<p class='com_status'>任职，控股</br></p>";
//   }
//   if(itemData.type == 7){
//     html += "<p class='com_status'>参股</br></p>";
//   }
//   if(itemData.type == 9){
//     html += "<p class='com_status'>十大股东投资</p>"
//   }
//   if((itemData.type.toString()).indexOf("6") == -1&&(itemData.type.toString()).indexOf("7") != -1&&(itemData.type.toString()).indexOf("2") != -1){
//     html += "<p class='com_status'>任职，参股</br></p>";
//   }
//   if((itemData.type.toString()).indexOf("6") != -1&&(itemData.type.toString()).indexOf("7")!= -1&&(itemData.type.toString()).indexOf("2") == -1){
//     html += "<p class='com_status'>控股</br></p>";
//   }
//   html += "<p class='com_detail'>"+item.to.label + "</br>";
//
//   // // 投资下的属性
//   // if((itemData.type.toString()).indexOf("1") != -1&&itemData.properties!=null){
//   //   html += "认缴出资日期："+(itemData.properties.condate || empty)  +"</br>";
//   //   html += "认缴出资额："+(itemData.properties.subconam || empty)  + " (万元）</br>";
//   //   html += "出资占比："+(itemData.properties.conprop*100 || empty)  +"%</br>";
//   // }
//   // // 十大股东属性
//   // if((itemData.type.toString()).indexOf("9") != -1){
//   //   html += "持股比例："+(itemData.properties.holderrto || empty)  +"%</br>";
//   //   html += "持股数量："+(itemData.properties.holderamt || empty)  + " (股)</br>";
//   //   html += "股份类型："+(itemData.properties.sharestype || empty)  +"</br>";
//   // }
//   // 工商总局和上市公司取并集
//   if(itemData.properties.holderrto){
//     html += "持股比例："+(itemData.properties.holderrto || empty)  +"%</br>";
//     html += "持股数量："+(itemData.properties.holderamt || empty)  + " (股)</br>";
//     html += "股份类型："+(itemData.properties.sharestype || empty)  +"</br>";
//   }else{
//     html += "认缴出资日期："+(itemData.properties.condate || empty)  +"</br>";
//     html += "认缴出资额："+(itemData.properties.subconam || empty)  + " (万元）</br>";
//     html += "出资占比："+(labelConprop || empty)  +"%</br>";
//   }
//   if(itemData.properties != null){
//     if(itemData.properties.position_desc){
//       html += "职位："+ (itemData.properties.position_desc || empty)  +"</br>";
//     }
//     if(itemData.properties.legal){
//       html += "担任法人代表</br>";
//     }
//   }
//
//
//   html +=  "</p>" ;
//   html += "</div>";
//   html += "</div>";
//   return html;
// }



// WEBPACK FOOTER //
// ./src/common/chartTipContent.js